import { ReactComponent as PrimaryShape } from "../../assets/shape-primary.svg";
import { ReactComponent as GrayShape } from "../../assets/shape-gray.svg";

export const TitleBadge: React.FC<{ title: string }> = ({ title }) => (
  <div className="relative inline-block w-full max-w-[80%] xl:max-w-md mx-auto lg:mx-0">
    <div className="relative">
      <PrimaryShape className="absolute left-0 w-full h-auto -translate-x-4 -translate-y-3 text-primary" />
      <GrayShape className="relative w-full h-auto" />
      <span className="pointer-events-none absolute inset-0 flex items-center justify-center px-6 font-extrabold text-white text-2xl lg:text-4xl">
        {title}
      </span>
    </div>
  </div>
);
